import React, { useState, memo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Card, CardContent, Collapse, ListItem, ListItemText, Button } from "@mui/material";
// import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Alert, Check } from "orion-components/CBComponents/Icons";
import SystemHealthItem from "./SystemHealthItem";
import { Translate, getTranslation } from "orion-components/i18n";

const propTypes = {
	title: PropTypes.string.isRequired,
	hasError: PropTypes.bool.isRequired,
	healthSystems: PropTypes.array,
	dir: PropTypes.string,
	locale: PropTypes.string
};

const defaultProps = {
	title: "",
	hasError: false,
	healthSystems: [],
	dir: "ltr",
	locale: "en"
};

const SystemHealthCard = ({ title, hasError, healthSystems, dir, locale }) => {
	const [expanded, setExpanded] = useState(false);

	const supportURL = useSelector(
		(state) =>
			state.session?.organization?.profile?.supportURL || "https://support.aressecuritycorp.com/support/login"
	);

	const handleExpand = () => {
		setExpanded(!expanded);
	};

	return (
		<Card
			style={{
				borderRadius: "5px",
				marginBottom: 12,
				background: "transparent"
			}}
		>
			<ListItem style={{ backgroundColor: "#494d53" }} data-testid="orion-components-dock-system-health-components-system-health-card-list-item">
				<div style={{ padding: "12px" }}>{hasError ? <Alert /> : <Check />}</div>
				<ListItemText
					style={{
						fontSize: "14px",
						color: "#FFF",
						textAlign: dir == "rtl" ? "right" : "left"
					}}
					primary={getTranslation(title)}
					primaryTypographyProps={{
						noWrap: true,
						variant: "body1"
					}}
				/>
				{healthSystems.length ? (
					<Button
						color="primary"
						variant="text"
						onClick={handleExpand}
						style={{
							fontSize: "14px",
							textTransform: "lowercase",
							color: "#3faede"
						}} data-testid="orion-components-dock-system-health-components-system-health-card-button"
					>
						{expanded ? (
							<Translate value="global.dock.systemHealth.systemHealthCard.hide" />
						) : (
							<Translate value="global.dock.systemHealth.systemHealthCard.more" />
						)}
					</Button>
				) : null}
			</ListItem>
			{expanded && 
				<Collapse in={expanded}>
					{title === "global.dock.systemHealth.server.coreSystem.title" ? (
						<CardContent
							style={{
								padding: dir && dir == "rtl" ? "0 30px 0 0" : "0 0 0 30px",
								backgroundColor: "#494d53"
							}}
						>
							<div
								style={{
									fontSize: "12px",
									lineHeight: "24px",
									padding: "5px 0 5px 0",
									paddingBottom: "20px"
								}}
							>
								<p
									style={{
										color: "white",
										fontWeight: "normal"
									}}
								>
									<Translate value="global.dock.systemHealth.server.coreSystem.notFullyOp" />{" "}
									<a className="app-link" target="_blank" href={supportURL} rel="noreferrer" data-testid="orion-components-dock-system-health-components-system-health-card-a">
										<span className="label">
											{getTranslation("global.dock.systemHealth.server.coreSystem.support")}
										</span>
									</a>
								</p>
							</div>
						</CardContent>
					) : (
						<CardContent
							style={{
								padding: dir && dir == "rtl" ? "0 50px 0 0" : "0 0 0 50px",
								backgroundColor: "#494d53"
							}}
						>
							{healthSystems.map((system, index) => {
								return (
									<div
										key={system.label}
										style={{
											lineHeight: "24px",
											padding: "5px 0 5px 0",
											...(index === healthSystems.length - 1 && {
												paddingBottom: "20px"
											})
										}}
									>
										<p
											style={{
												color: "white",
												fontWeight: "bold"
											}}
										>
											{getTranslation(system.label)}
										</p>
										{system.checks.map((check) => {
											return <SystemHealthItem key={check.id} check={check} locale={locale} />;
										})}
										{index !== healthSystems.length - 1 && <hr style={{ width: "90%" }} />}
									</div>
								);
							})}
						</CardContent>
					)}
				</Collapse>
			}
		</Card>
	);
};

SystemHealthCard.propTypes = propTypes;
SystemHealthCard.defaultProps = defaultProps;

export default memo(SystemHealthCard);
